import { useMutation } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import { UserController } from 'src/controllers/user.controller'
import { ChangePasswordDto } from 'src/dto/user.dto'

const userController = new UserController()

export function useChangePassword() {
  return useMutation({
    mutationFn: (changePasswordDto: ChangePasswordDto) => userController.changePassword(changePasswordDto),
    onError: () => {
      toast.error('Erro ao alterar senha')
    }
  })
}
